<template>
  <div class="container-fluid care-check-print-print">
    <div
      class="v-clean p-5 text-center mt-5"
      v-if="prescriptionsResidents.length == 0 && !loading"
    >
      <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
    </div>

    <b-overlay :show="loading" opacity="0.99">
      <div
        v-if="prescriptionsResidents.length > 0"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right div-btn-print"
      >
        <v-btn @click="handlePrint" class="btn-print">
          <i class="fas fa-print mr-2 text-twenty"></i>IMPRIMIR
        </v-btn>
      </div>

      <div
        v-for="(prescriptionsResident, residentKey) in prescriptionsResidents"
        :key="residentKey"
      >
        <div v-if="prescriptionsResident.prescriptions.length > 0">
          <table
            class="table-leaves table-sm bg-white"
            v-for="(leave, leaveKey) in separate(
              prescriptionsResident.days,
              15
            )"
            :key="leaveKey"
            cellpadding="0"
            cellspacing="0"
          >
            <ResidentDataPrintPrescriptionLote
              :resident_id="prescriptionsResident.resident.id"
            />

            <!-- Conteúdo da tabela -->
            <div class="content mb-5">
              <h6 class="title-one text-center mt-7">
                Prescrição Cuidado - Validade
                <span class="color-blue">{{
                  formatDate(
                    prescriptionsResident.group_prescription_care.start_date,
                    false
                  )
                }}</span>
                até
                <span class="color-blue">{{
                  formatDate(
                    prescriptionsResident.group_prescription_care.end_date,
                    false
                  )
                }}</span>
              </h6>

              <div
                class="text-center"
                v-if="userData().show_user_on_print == 1"
              >
                Gerado por
                {{
                  professionalClassCouncilValue({
                    id: user.professional_class_council_id,
                    name: user.name,
                    profile: user.profile_name,
                    cpf: user.cpf,
                    office: user.office,
                    value: user.professional_class_council_value,
                  })
                }}
                <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
              </div>

              <table class="table-bordered" cellpadding="0" cellspacing="0">
                <thead>
                  <th>CUIDADO</th>
                  <th class="text-center">HORÁRIO</th>
                  <th
                    v-for="item in leave"
                    :key="item"
                    v-show="item"
                    class="text-center"
                  >
                    {{ formatDateDayMonth(item) }}
                  </th>
                </thead>

                <tbody>
                  <tr
                    v-for="(
                      prescription, index
                    ) in prescriptionsResident.prescriptions"
                    :key="`${residentKey}-${index}-${prescription.care.id}`"
                    v-show="prescription.items.length > 0"
                    class="tr-inf"
                  >
                    <td style="padding: 1px !important">
                      <h6 class="mb-0 text-thirteen">
                        {{ index + 1 }} -
                        <strong>{{ prescription.care.care_name }}</strong>
                      </h6>
                      <h6 class="text-thirteen worksansr mb-1">
                        {{ prescription.care.care_active_ingredient }}
                      </h6>
                      <h6
                        class="mb-0 worksansr text-thirteen"
                        v-if="prescription.care.instruction"
                      >
                        {{ prescription.care.instruction }}
                      </h6>
                    </td>

                    <td style="padding: 1px !important">
                      <h6
                        class="mb-0 text-thirteen text-center"
                        v-if="!prescription.prescription_care_time.time"
                      >
                        <strong>EVENTUAL</strong>
                      </h6>
                      <h6
                        class="mb-0 text-thirteen text-center"
                        v-if="prescription.prescription_care_time.time"
                      >
                        {{
                          String(
                            prescription.prescription_care_time.time
                          ).substr(0, 5)
                        }}
                      </h6>
                    </td>

                    <td
                      v-for="item in prescription.items"
                      v-show="leave.includes(item.show_date)"
                      :key="item.show_date"
                      style="padding: 1px !important"
                    >
                      <Daily
                        v-if="
                          item.status != 'NAO_MOSTRAR' &&
                          item.item.frequency == 'DIARIO'
                        "
                        :item="item"
                      />
                      <Weekly
                        v-if="
                          item.status != 'NAO_MOSTRAR' &&
                          item.item.frequency == 'SEMANAL'
                        "
                        :item="item"
                      />
                      <Monthly
                        v-if="
                          item.status != 'NAO_MOSTRAR' &&
                          item.item.frequency == 'MENSAL'
                        "
                        :item="item"
                      />
                      <Yearly
                        v-if="
                          item.status != 'NAO_MOSTRAR' &&
                          item.item.frequency == 'ANUAL'
                        "
                        :item="item"
                      />
                      <Eventual
                        v-if="item.item.frequency == 'EVENTUAL'"
                        :item="item"
                      />
                      <div
                        class="text-center"
                        v-if="item.check_anticipated == 1"
                      >
                        <i class="fas fa-clock icon-check-anticipated"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>

      <div
        v-if="prescriptionsResidents.length > 0"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right div-btn-print"
      >
        <v-btn @click="handlePrint" class="btn-print">
          <i class="fas fa-print mr-2 text-twenty"></i>IMPRIMIR
        </v-btn>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ResidentDataPrintPrescriptionLote from "../../../../../components/resident/ResidentDataPrintPrescriptionLote";

import Daily from "../../Prescription/ViewCare/Daily.vue";
import Eventual from "../../Prescription/ViewCare/Eventual";
import Monthly from "../../Prescription/ViewCare/Monthly";
import Weekly from "../../Prescription/ViewCare/Weekly";
import Yearly from "../../Prescription/ViewCare/Yearly";

import api from "../../../../../services/api";
import routes from "../../../../../routes";

import { userData } from "../../../../../lib/functions";
import { getAge } from "../../../../../lib/getAgeByDate";
import {
  formatDate,
  categoryCoren,
  onlyCategoryCoren,
  formatDateDayMonth,
  formatDateOnlyNumbers,
  formatTimeOnlyNumbers,
  professionalClassCouncilValue,
} from "../../../../../lib/format";

import moment from "moment";
import { showUserOnPrint } from "../../../../../lib/show-user-on-print";

export default {
  name: "CareMultipleResident",

  components: {
    ResidentDataPrintPrescriptionLote,
    Daily,
    Eventual,
    Monthly,
    Weekly,
    Yearly,
  },

  data() {
    return {
      order_by: "",
      frequency: "",
      rest_home_id: "",
      resident_ids: [],
      date: "",
      end_date: "",
      user: {},
      rest_home_name: "",
      rest_home_logo_url: "",
      prescriptionsResidents: [],
      errors: [],
      logo: "",
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getAge,
    moment,
    formatDate,
    categoryCoren,
    onlyCategoryCoren,
    formatDateDayMonth,
    formatDateOnlyNumbers,
    formatTimeOnlyNumbers,
    professionalClassCouncilValue,
    userData,

    async retrieve() {
      let { rest_home_id, user, logo } = userData();

      this.rest_home_id = rest_home_id;
      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      let { show_user_on_print } = userData();
      if (show_user_on_print != 1) {
        await showUserOnPrint({
          about: "Rotina diária prescrição de cuidado",
        });
      }

      const { resident_ids, date, end_date, order_by, frequency } =
        routes.history.current.params;

      this.resident_ids = resident_ids.split(",");
      this.date = date;
      this.end_date = end_date;
      this.order_by = order_by;
      this.frequency = frequency;

      await this.get();
    },

    async get() {
      try {
        this.loading = true;
        this.errors = [];

        const {
          rest_home_id,
          resident_ids,
          date,
          end_date,
          order_by,
          frequency,
        } = this;

        let params = {
          rest_home_id,
          resident_ids,
          date,
          end_date,
          order_by,
          frequency,
          type: "NORMAL",
          filter: false,
        };

        const response = await api.get(
          "/rest-home/multiple-resident/care-check-print",
          { params }
        );

        const { error, errors, prescriptionsResidents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.prescriptionsResidents = prescriptionsResidents;
        }

        setTimeout(() => (this.loading = false), 200);
      } catch (error) {
        console.log(error);
      }
    },

    // Divide o array de dias em grupos de `max` para paginação da tabela
    separate(base, max) {
      let result = [[]];
      let group = 0;

      for (let indice = 0; indice < base.length; indice++) {
        if (result[group] === undefined) {
          result[group] = [];
        }

        result[group].push(base[indice]);

        if ((indice + 1) % max === 0) {
          group = group + 1;
        }
      }

      return result;
    },

    handlePrint() {
      window.print();
    },
  },
};
</script>

<style>
@media print and (-webkit-min-device-pixel-ratio: 0) {
}

.care-check-print-print .header,
.care-check-print-print .header-space {
  height: 100px;
}
.care-check-print-print .header {
  position: fixed;
  top: 0;
}
.care-check-print-print .name {
  font-weight: bold;
}
.care-check-print-print .active-ingredient {
  font-size: 12px;
}
.care-check-print-print .via {
  font-weight: bold;
  font-size: 12px;
}
.care-check-print-print .user {
  width: 20px;
}
.care-check-print-print .checked-icon {
  width: 15px;
}
.care-check-print-print .logo {
  height: 50px;
  object-fit: contain;
}
.care-check-print-print .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.care-check-print-print .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 50% !important;
  object-fit: cover;
}

.care-check-print-print table,
.care-check-print-print td,
.care-check-print-print th,
.care-check-print-print tfoot {
  width: 100% !important;
  padding: 5px;
  cursor: auto !important;
}

@media print {
  @page {
    size: landscape;
    margin: 0cm 0cm 0cm 0cm;
  }
  .care-check-print-print .header {
    width: 100% !important;
    position: fixed;
    top: 0;
  }
  .care-check-print-print .header,
  .care-check-print-print .header-space {
    height: 150px;
  }
  .care-check-print-print button,
  .care-check-print-print .div-btn-print {
    display: none !important;
  }
  .care-check-print-print .table-leaves {
    page-break-after: always !important;
  }
  * {
    box-sizing: border-box !important;
  }
}
</style>